import React from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';
import BackButton from './BackButton';

function UploadPlates() {
  const navigate = useNavigate();

  const handleUploadFiles = () => {
    navigate('/quick-start-guide-plates');
  };

  const handleTakePhotos = () => {
    navigate('/license-plate-photography');
  };

  const handleSupportClick = () => {
    navigate('/support');
  };

  return (
    <div className="UploadPlates">
      <h1 className="UploadPlates-title">
        Send us your custom<br />dealer plate and/or frame
      </h1>
      <div className="UploadPlates-options">
        <div className="UploadPlates-option" onClick={handleUploadFiles}>
          <div className="UploadPlates-image-placeholder">
            <span style={{ fontSize: 48 }}>⬆️</span>
          </div>
          <div className="UploadPlates-label">
            Upload Existing<br />Digital Files
            <div className="UploadPlates-preferred">*Preferred Method*</div>
          </div>
        </div>
        <div className="UploadPlates-option" onClick={handleTakePhotos}>
          <div className="UploadPlates-image-placeholder">
            <span style={{ fontSize: 40 }}>📷</span>
          </div>
          <div className="UploadPlates-label">
            Take and Upload<br />Photos
          </div>
        </div>
      </div>
      <div className="UploadPlates-support">
        Questions?{' '}
        <span className="support-link" onClick={handleSupportClick}>Click here</span>
        {' '}to reach out to our support team directly.
      </div>
      <BackButton />
    </div>
  );
}

export default UploadPlates;
